import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CheckboxService {
    private subject = new Subject<any>();

    onClick(data:any): void {
        this.subject.next(data);
    }

    doCheckboxAction(): Observable<any> {
        return this.subject.asObservable();
    }
}
